import { Array, Boolean, Partial, Record, String, Undefined } from "runtypes";
import { clean } from "./clean";
import { PERSONABLE_MENTOR_COLLECTION } from "./collections";
import { SEMESTER } from "./current";
import { StaffRoles } from "./role";
export const MENTORING_START_DAYS = 7;
export const MentorAssignment = Record({
  semester: String,
  from: String,
  to: String,
  generation: String,
  latest: Boolean,
  staff: Boolean
}).And(
  Partial({
    level: StaffRoles
  })
);
export const loadMentor = async (db, netID, semester = SEMESTER) => {
  return MentorAssignment.Or(Undefined).check(
    clean(await db.collection(PERSONABLE_MENTOR_COLLECTION).findOne({ semester, staff: true, latest: true, to: netID }))
  )?.from;
};
export const loadMentees = async (db, netID, semester = SEMESTER) => {
  return Array(MentorAssignment).check(
    await db.collection(PERSONABLE_MENTOR_COLLECTION).find({ semester, staff: true, latest: true, from: netID }).toArray()
  ).map(({ to }) => to);
};
//# sourceMappingURL=mentor.js.map
